module.exports = __webpack_public_path__ + "img/T5-B-rc12.c93d40fb.png";